import { useState, useEffect, useRef, useCallback } from 'react';
import dialerService from '../services/dialerService';

export const useDialerTimer = () => {
  const [times, setTimes] = useState({
    dialerTime: 0,
    talkTime: 0,
    acwTime: 0,
    idleTime: 0,
    breakTime: 0
  });
  const [timerMode, setTimerMode] = useState('endcall'); // 'greencall', 'holdcall', 'endcall'
  const [activeSubMode, setActiveSubMode] = useState('dialerTime'); // 'talkTime', 'acwTime', etc.
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const intervalRef = useRef(null);
  const lastSyncRef = useRef(0);

  const startTimer = useCallback(() => {
    setIsTimerRunning(true);
  }, []);

  const stopTimer = useCallback(() => {
    setIsTimerRunning(false);
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    // Sync final data
    syncData();
  }, [times]);

  const syncData = useCallback(async () => {
    try {
      await dialerService.updateDialerData('DialerTimeUpdate', {
        DialerTimeSec: times.dialerTime,
        TalkTimeSec: times.talkTime,
        IdleTimeSec: times.idleTime,
        AcwTimeSec: times.acwTime,
        BreakTimeSec: times.breakTime
      });
    } catch (error) {
      console.error('Failed to sync dialer times', error);
    }
  }, [times]);

  useEffect(() => {
    if (isTimerRunning) {
      intervalRef.current = setInterval(() => {
        setTimes(prev => {
          const newTimes = { ...prev };
          newTimes.dialerTime += 1;

          if (activeSubMode === 'idleTime') newTimes.idleTime += 1;
          else if (activeSubMode === 'talkTime') newTimes.talkTime += 1;
          else if (activeSubMode === 'acwTime') newTimes.acwTime += 1;
          else if (activeSubMode === 'breakTime') newTimes.breakTime += 1;

          // Sync every 30 seconds
          if (newTimes.dialerTime > 0 && newTimes.dialerTime % 30 === 0 && newTimes.dialerTime !== lastSyncRef.current) {
            lastSyncRef.current = newTimes.dialerTime;
            syncData(newTimes);
          }

          return newTimes;
        });
      }, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }
    return () => clearInterval(intervalRef.current);
  }, [isTimerRunning, activeSubMode, syncData]);

  return {
    times,
    timerMode,
    setTimerMode,
    activeSubMode,
    setActiveSubMode,
    isTimerRunning,
    startTimer,
    stopTimer,
    syncData
  };
};
